import React from 'react';
import { format, parseISO } from 'date-fns';
import flow from 'lodash/fp/flow';
import groupBy from 'lodash/fp/groupBy';
import sortBy from 'lodash/fp/sortBy';

import './ShoppingCartItinerary.scss';
import { useTranslation } from '../../../hooks';
import { ShoppingCartItem } from '../index';
import { formatPrice, getNumberOfGuests } from '@fshr/shared';

export default function ShoppingCartItinerary({
	itinerary,
	removeItem,
	insideCart = false,
	handleShowInfoModal,
}) {
	const { t } = useTranslation();

	const timeSlots = ['morning', 'lunch time', 'afternoon', 'dusk', 'evening'];

	const sortByTreatmentDate = ({ date }) => date;

	const sortByTreatmentTime = ({ timeOfDay }) => {
		return timeSlots.indexOf(timeOfDay);
	};

	const groupedOrderedSpaEvents = flow(
		sortBy([sortByTreatmentDate, sortByTreatmentTime]),
		groupBy(({ date, timeOfDay }) => {
			return `${date}|${timeSlots.indexOf(timeOfDay?.toLowerCase())}`;
		})
	)(itinerary);

	return (
		<div className="summary-itinerary">
			{Object.keys(groupedOrderedSpaEvents).map(key => {
				const [date, timeSlotIndex] = key.split('|');
				const dateTimeToRender = [
					format(parseISO(date), 'MMM d'),
					timeSlots[timeSlotIndex], // might be undefined, and will get filtered out
				]
					.filter(Boolean)
					.join(', ');

				return (
					<div key={key}>
						<div className="summary-itinerary__date ty-c3">{dateTimeToRender}</div>

						<div className="summary-itinerary__items">
							{groupedOrderedSpaEvents[key].map(
								({
									productId,
									name,
									productTotal,
									onRequestEventProductType,
									price,
									numAdults,
									numChildren,
									images,
									complimentaryPricingInfo,
								}) => {
									return (
										<div key={productId}>
											{!insideCart && onRequestEventProductType ? (
												<div className="ty-h4 summary-itinerary__items__type">
													{onRequestEventProductType}
												</div>
											) : undefined}

											<ShoppingCartItem
												name={name}
												duration={price?.priceName}
												numberOfPeople={getNumberOfGuests({
													t,
													numberOfAdults: numAdults,
													numberOfChildren: numChildren,
												})}
												price={productTotal.totalPrice.amount}
												currencyCode={productTotal.totalPrice.currencyCode}
												complimentaryPricingInfo={complimentaryPricingInfo}
												removeItem={() =>
													removeItem({
														productId,
													})
												}
												insideCart={insideCart}
												image={images?.[0]?.url}
												onRequestEventProductType={onRequestEventProductType}
												unitType={price.priceDetail}
												showInfoModal={() => {
													const hotelProduct = {
														productId,
														name,
														productTotal,
														price,
														numAdults,
														numChildren,
													};
													handleShowInfoModal(
														hotelProduct,
														formatPrice(
															productTotal.totalPrice.amount,
															productTotal.totalPrice.currencyCode
														)
													);
												}}
											/>
										</div>
									);
								}
							)}
						</div>
					</div>
				);
			})}
		</div>
	);
}
